import { render, staticRenderFns } from "./MessageList.vue?vue&type=template&id=fa879b60&scoped=true"
import script from "./MessageList.vue?vue&type=script&lang=ts"
export * from "./MessageList.vue?vue&type=script&lang=ts"
import style0 from "./MessageList.vue?vue&type=style&index=0&id=fa879b60&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa879b60",
  null
  
)

export default component.exports